import { DurationUnit } from '@wix/premium-cart-sdk';
export const extractAvailableCyclesFromPricing = pricingDetails => {
  // First collect all durations
  const durationsByUnit = pricingDetails.reduce((acc, curr) => {
    var _curr$cycle;
    const {
      unit,
      count
    } = ((_curr$cycle = curr.cycle) == null ? void 0 : _curr$cycle.cycleDuration) ?? {};
    if (unit && unit !== 'UNKNOWN_UNIT' && count && count > 0) {
      if (!acc[unit]) {
        acc[unit] = [];
      }
      if (!acc[unit].includes(count)) {
        acc[unit].push(count);
      }
    }
    return acc;
  }, {});

  // Sort all arrays and filter out empty ones
  const result = {};
  for (const unit in durationsByUnit) {
    var _durationsByUnit$unit;
    if ((_durationsByUnit$unit = durationsByUnit[unit]) != null && _durationsByUnit$unit.length) {
      result[unit] = durationsByUnit[unit].sort((a, b) => a - b);
    }
  }
  return result;
};
const modifyLineItemCycle = (lineItems, cycle) => {
  const filteredLineItems = clearEmptyLineItems(lineItems);
  return Object.entries(filteredLineItems).reduce((acc, _ref) => {
    let [key, value] = _ref;
    acc[key] = {
      ...value,
      cycle
    };
    return acc;
  }, {});
};
export const findClosestAvailableCycle = (requestedCycle, availableCycleDurations) => {
  var _requestedCycle$cycle, _availableCycleDurati;
  if (!((_requestedCycle$cycle = requestedCycle.cycleDuration) != null && _requestedCycle$cycle.unit) || !(availableCycleDurations != null && availableCycleDurations[requestedCycle.cycleDuration.unit]) || availableCycleDurations != null && (_availableCycleDurati = availableCycleDurations[requestedCycle.cycleDuration.unit]) != null && _availableCycleDurati.includes(requestedCycle.cycleDuration.count)) {
    // Current cycle is valid, return as is
    return requestedCycle;
  }
  const currentCount = requestedCycle.cycleDuration.count || 0;
  const availableDurations = availableCycleDurations[requestedCycle.cycleDuration.unit] || [];

  // Find the largest duration that's smaller than the requested one
  const closestLowerDuration = availableDurations.filter(duration => duration < currentCount).sort((a, b) => b - a)[0];

  // If no lower duration exists, take the smallest available
  const bestDuration = closestLowerDuration !== undefined ? closestLowerDuration : availableDurations.sort((a, b) => a - b)[0] || 1;
  return {
    ...requestedCycle,
    cycleDuration: {
      ...requestedCycle.cycleDuration,
      count: bestDuration
    }
  };
};
export const transformDomainLineItems = (domainLineItem, domainAddonLineItem, cycle) => {
  if (domainLineItem.status === 'fulfilled') {
    var _cycle$cycleDuration, _availableCycleDurati2, _cycle$cycleDuration2, _cycle$cycleDuration3;
    const availableCycleDurations = extractAvailableCyclesFromPricing(domainLineItem.value.productInfo.pricingDetails ?? []);
    if (((_cycle$cycleDuration = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration.unit) === DurationUnit.YEAR && !(availableCycleDurations != null && (_availableCycleDurati2 = availableCycleDurations[(_cycle$cycleDuration2 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration2.unit]) != null && _availableCycleDurati2.includes((_cycle$cycleDuration3 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration3.count))) {
      // Will be used to modify the cycle to the closest lower available one
      // For example, if the requested cycle is 3 year and the closest lower available cycle is 2 years,
      // the modified cycle will be 2 years
      const modifiedCycle = findClosestAvailableCycle(cycle, availableCycleDurations);
      const modifiedLineItems = modifyLineItemCycle({
        domainLineItem: domainLineItem.value,
        domainAddonLineItem: domainAddonLineItem.status === 'fulfilled' ? domainAddonLineItem.value : undefined
      }, modifiedCycle);
      return modifiedLineItems;
    }
    return clearEmptyLineItems({
      domainLineItem: domainLineItem.value,
      domainAddonLineItem: domainAddonLineItem.status === 'fulfilled' ? domainAddonLineItem.value : undefined
    });
  }
  throw new Error("Can't find product");
};
export function clearEmptyLineItems(lineItems) {
  return Object.entries(lineItems).reduce((acc, _ref2) => {
    let [key, value] = _ref2;
    // Filter out null, undefined, or empty objects
    if (value !== null && value !== undefined && (typeof value !== 'object' || Object.keys(value).length > 0)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
//# sourceMappingURL=index.js.map